export default __webpack_public_path__ + "static/media/Text(Bid with caution).ba1ca4fb.svg";